<template>
  <v-btn
    :id="id"
    :prepend-icon="prependIcon"
    :color="color"
    :type="type"
    :to="routeLink"
    v-bind="$props"
    @click="click"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
    name: "PsButton",
    props: {
        id: {
            type: String,
            required: false,
            default: "btn"
        },
        color: {
            type: String,
            required: false,
            default: "#003F64"
        },
        type: {
            type: String,
            required: false,
            default: "button"
        },
        prependIcon: {
            type: String,
            default: null
        },
        value: {
            type: String,
            required: false,
            default: ""
        },
        click: {
            type: Function,
            required: false,
            default: () => {}
        },
        routeLink: {
            type: String,
            required: false,
            default: null
        },
        text: {
            type: Boolean,
            required: false,
            default: false
        },
        depressed: {
            type: Boolean,
            required: false,
            default: false
        },
        raised: {
            type: Boolean,
            required: false,
            default: false
        },
        fab: {
            type: Boolean,
            required: false,
            default: false
        },
        href: {
            type: String,
            required: false,
            default: ""
        },
        exactActiveClass: {
            type: String,
            required: false,
            default: ""
        },
        dark: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
